/**
 * API Routes Constants (Legacy - For Backward Compatibility)
 * 
 * DEPRECATED: This file is maintained for backward compatibility.
 * For new implementations, please use:
 * - @/routes/constants for all route constants
 * - API_ROUTES from @/routes/constants for API endpoints
 * 
 * TODO: Refactor all imports to use new route structure
 */

// Re-export from new location for backward compatibility
import { 
  API_ROUTES as NEW_API_ROUTES, 
  AUTH_ROUTES,
  PUBLIC_ROUTES,
  PROTECTED_ROUTES
} from '@/routes/constants';

/**
 * API Routes Constants
 * Centralized API endpoint definitions
 */
export const API_ROUTES = NEW_API_ROUTES;

/**
 * Application Routes Constants
 * Frontend route paths
 */
export const APP_ROUTES = {
  HOME: PUBLIC_ROUTES.HOME,
  LOGIN: AUTH_ROUTES.LOGIN,
  REGISTER: AUTH_ROUTES.REGISTER,
  FORGOT_PASSWORD: AUTH_ROUTES.FORGOT_PASSWORD,
  RESET_PASSWORD: AUTH_ROUTES.RESET_PASSWORD,
  DASHBOARD: PROTECTED_ROUTES.DASHBOARD,
  PROFILE: PROTECTED_ROUTES.PROFILE,
  NOT_FOUND: '/404',
};

export default { API_ROUTES, APP_ROUTES };
